import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import {
  LocalWidgetRouterContext,
  LocalWidgetRouterState,
} from '@/core/widgets/contexts/local-widget-router-context';

export default function useWidgetParams() {
  const context = useContext<LocalWidgetRouterState>(LocalWidgetRouterContext);
  const d = useParams();

  if (context.useLocal) {
    return context.params;
  }

  return d;
}
